/* eslint-disable  */

import { Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import LikeIcon from "../../assets/like.png";

const ThankYouSubmitEnquiry = () => {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ padding: 10 }}
    >
      <Grid item style={{ marginTop: 50 }}>
        <img src={LikeIcon} alt="image1" style={{ objectFit: "cover" }} />
      </Grid>
      <Grid item style={{ paddingTop: 20 }}>
        <Typography
          variant="h6"
          style={{
            fontSize: 40,
            fontWeight: "normal",
            color: "#c72027",
          }}
        >
          Thank You
        </Typography>
      </Grid>
      <Grid item style={{ paddingTop: 20 }}>
        <Typography variant="caption" style={{ fontSize: 16 }}>
          For Submitting Your Enquiry!
        </Typography>
      </Grid>

      <Grid item style={{ paddingTop: 40, textAlign: "center" }}>
        <Typography
          variant="caption"
          style={{ fontSize: 16, textAlign: "center" }}
        >
          Our Admissions team will guide regarding the admission process, fee
          structure and curriculum during your campus visit
        </Typography>
      </Grid>
      {window.opener != null || window.history.length == 1 ? (
        <Grid item style={{ paddingTop: 40, textAlign: "center" }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              window.close();
            }}
          >
            Back To Home
          </Button>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default ThankYouSubmitEnquiry;
